import { render, staticRenderFns } from "./entity-form-property.vue?vue&type=template&id=49f6dc36&"
import script from "./entity-form-property.vue?vue&type=script&lang=js&"
export * from "./entity-form-property.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports